import { schemaDocumentSnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '../../schema'

export const regionQuery = (regionId: string | undefined | null) =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['regions', regionId],
    factory: collections.regions,
    id: regionId,
  })
